export const csrfToken = () => {
  const cookies = document.cookie.split('; ')
  const token = cookies.find(row => row.startsWith('CSRF-TOKEN='))

  if (token) {
    return token.split('=')[1]
  }
}
